import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Option } from '../../shared/feature-utils';
import { InheritableOnOffFeature } from '../../shared/on-off-feature.model';

@Component({
  selector: 'app-feature-editor',
  templateUrl: './feature-editor.component.html',
  styleUrls: ['./feature-editor.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class FeatureEditorComponent implements OnInit {

  @Input()
  model: any;

  @Output()
  modelChange = new EventEmitter<any>();

  @Input()
  groupName: string;

  @Input()
  translationNode: string;

  @Input()
  regionValue: any;

  @Input()
  possibleValues: Option[] = [];

  @Input()
  disabled: boolean;

  @Input()
  hasError = false;

  @Input()
  warningLabelKey = '';

  protected readonly InheritableOnOffFeature = InheritableOnOffFeature;

  constructor() {
  }

  ngOnInit() {
  }

  modelChanged() {
    this.modelChange.emit(this.model);
  }
}
